import { Theme } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

export default function Skeleton(theme: Theme, containerId: string) {
  return {
    MuiSkeleton: {
      defaultProps: {
        container: document.getElementById(containerId),
        animation: 'wave',
      },
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.neutral,
        },
      },
    },
  };
}
